<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<!-- Header -->
<header class="fixed-top">
  <div class="header-col">
    <button
      type="button"
      class="sidebar-toggler"
      (click)="toggleSidebar()"
      [ngClass]="{ open: showSidebar }"
      >
      <span class="toggler-icon"></span>
    </button>
  </div>
  <div class="header-col text-center"></div>
</header>

<!-- Sidebar -->
<nav class="sidebar" [ngClass]="{ open: showSidebar }">
  <swiper-container
    #swiperRef
    direction="vertical"
    slides-per-view="auto"
    mousewheel="true"
    free-mode="true"
    scrollbar="true"
    class="swiper-container"
    >
    <swiper-slide>
      <div class="user-details">
        @if (connectedUser?.photoURL) {
          <div class="avatar">
            <img
              class="avatar-image"
              [src]="connectedUser?.photoURL ?? 'assets/images/avatar-placeholder.svg'"
              alt=""
              />
          </div>
        }
        <div class="text">
          <p class="welcome-text">Welcome</p>
          <p class="username">{{ connectedUser?.displayName }}</p>
        </div>
        <div class="logout">
          <button type="button" class="btn btn-link text-danger" (click)="logout()">Logout</button>
        </div>
      </div>

      <!--  Menu Items  -->
      <ul class="nav flex-column">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/home']" [routerLinkActive]="'active'">
            <fa-icon [icon]="faHome"></fa-icon>
            Home
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/stores']" [routerLinkActive]="'active'">
            <fa-icon [icon]="faTh"></fa-icon>
            Stores
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/adminUsers']" [routerLinkActive]="'active'">
            <fa-icon [icon]="faUsersCog"></fa-icon>
            Admin Users
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/deleteUser']" [routerLinkActive]="'active'">
            <fa-icon [icon]="faUserGear"></fa-icon>
            Manage Users
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/media']" [routerLinkActive]="'active'">
            <fa-icon [icon]="faFileUpload"></fa-icon>
            Media files
          </a>
        </li>
      </ul>
    </swiper-slide>
  </swiper-container>
</nav>

<!-- Main -->
<main role="main">
  <router-outlet></router-outlet>
</main>

<!-- Footer -->
<footer>
  <div class="container-lg">
    <div class="row">
      <div class="col-12">
        <div class="footer-lower">
          <div class="legal">
            <p>© All rights reserved Terrific {{ currentYear }}</p>
          </div>
          <div class="menu">
            <ul class="list-unstyled">
              <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
              <li><a class="logout" (click)="logout()">Logout</a></li>
              <li><a [routerLink]="['/stores']">Stores</a></li>
              <li><a [routerLink]="['/adminUsers']">Admin Users</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
